<template>
  <div>
    <v-img
      src="@/assets/GreyBG.png"
      width="100%"
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh' }
          : { height: '100vh' },
      ]"
    >
      <div>
        <v-container>
          <v-row style="min-height: 90vh" justify="center" align="center">
            <v-card
              width="400"
              :class="$vuetify.breakpoint.xs ? 'rounded-0' : 'rounded-lg'"
            >
              <v-card-text style="width: auto">
                <v-tabs class="d-none" v-model="model"> </v-tabs>
                <v-tabs-items v-model="model">
                  <v-tab-item :value="`tab-1`">
                    <div align="center">
                      <v-img class="image-container" width="200"
                        @click="OpenCheckPermissionDialog()"
                        :src="LogoImageString"
                      ></v-img>
                    </div>
                    <br/>
                    <p
                      align="center"
                      style="color: #edc000; font-size: 20px; font-weight: bold"
                    >
                      <!-- <span style="color: #5dbeef; font-weight: bold"> -->

                      <span class="Header_Color" :style="[{ color: HeaderColor == '' ? 'black' : HeaderColor }]">
                        {{ HeaderName == "" ? "Parking Redemption" : HeaderName }}</span
                      >
                    </p>

                    <v-row style="margin-bottom: -50px">
                      <v-col cols="12" md="1"></v-col>
                      <v-col cols="12" md="10">
                        <v-text-field
                          placeholder="Username"
                          name="login"
                          type="text"
                          outlined
                          v-model="username"
                          @keyup.enter="Login"
                        />
                      </v-col>
                      <v-col cols="12" md="1"></v-col>
                    </v-row>

                    <v-row style="margin-bottom: -50px">
                      <v-col cols="12" md="1"></v-col>
                      <v-col cols="12" md="10">
                        <v-text-field
                          outlined
                          placeholder="Password"
                          type="password"
                          id="password"
                          @keyup.enter="Login"
                          v-model="password"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="1"
                        class="mt-4"
                        v-if="$vuetify.breakpoint.width >= 1024"
                      >
                        <v-icon
                          v-show="flagPassword == true"
                          style="margin-left: -60px"
                          @click="TogglePassword()"
                          >mdi-eye-off</v-icon
                        >
                        <v-icon
                          v-show="flagPassword == false"
                          style="margin-left: -60px"
                          @click="TogglePassword()"
                          >mdi-eye</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="1"></v-col>
                      <v-col cols="12" md="10">
                        <v-btn v-if="FontColor != ''"
                          block
                          :color="
                            ThemeColor == '' || ActiveStatus == '2'
                              ? '#1D2939'
                              : ThemeColor
                          "
                          :style="[{ color: FontColor }]"
                          @click="Login()"
                          class="rounded-lg"
                          x-large
                          >Login</v-btn
                        >
                        <v-btn v-else
                          block
                          :color="
                            ThemeColor == '' || ActiveStatus == '2'
                              ? '#1D2939'
                              : ThemeColor
                          "
                          :style="[{ color: 'white' }]"
                          @click="Login()"
                          class="rounded-lg"
                          x-large
                          >Login</v-btn
                        >
                      </v-col>
                      <v-col cols="12" md="1"></v-col>
                    </v-row>
                    <br />
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </div>
    </v-img>
    <v-footer
      :color="ThemeColor == '' || ActiveStatus == '2' ? '#1d2939' : ThemeColor"
      :absolute="$vuetify.breakpoint.height < 786 ? true : true"
      class="white--text text-caption footer"
    >
    <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="4" md="4" lg="2"></v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="1">
              <v-img
                src="@/assets/logo_fs.svg"
                width="80"
                class="mx-auto mt-1"
              ></v-img>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="3">
              <div class="mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © 2023 Forward System Co. Ltd. All rights reserved.</span
                >
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="6"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-footer>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckPermissionDialog" persistent width="300">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseCheckPermissionDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row style="margin-bottom: -50px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-text-field
                placeholder="Username"
                type="text"
                outlined
                v-model="UserAdmin"
                @keyup.enter="LoginPermission"
              />
              <v-text-field
                placeholder="Password"
                type="password"
                outlined
                v-model="PasswordAdmin"
                @keyup.enter="LoginPermission"
              />
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row style="margin-bottom: -40px">
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-btn
                block
                color="#1D2939"
                style="color: white"
                @click="LoginPermission()"
                class="rounded-lg"
                x-large
                >Login</v-btn
              >
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SettingLoginDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>Setting</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="CloseSettingLogin()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="ml-5 mr-2">
            <v-col col="12" md="6">
              <p style="text-align: center; font-size: 16px; color: black">
                Logo Image
              </p>
              <img
                v-if="!LogoImageString"
                height="120px"
                width="170px"
                style="
                  padding-top: 0rem;
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                "
                src="@/assets/JLK_Logo.png"
              />
              <img
                v-else
                :src="LogoImageString"
                height="120px"
                width="170px"
                style="
                  margin-left: -0.7rem;
                  margin-right: -0.7rem;
                  margin-top: -0.5rem;
                  display: block;
                  margin-left: auto;
                  margin-right: auto;
                "
              />
              <div
                class="file-wrapper"
                style="padding-top: 1rem"
                align="center"
              >
                <v-btn
                  color="primary"
                  class="white--text mt-2 text-capitalize"
                  router
                  width="150"
                  @click="onPickFile"
                  >Upload</v-btn
                >
                <input
                  style="display: none"
                  ref="fileimagelogo"
                  id="file-upload"
                  accept="image/*"
                  name="file-input"
                  type="file"
                  @change="handleFileInputLogo"
                />
              </div>

              <!-- <p style="text-align: left; font-size: 16px; color: black">
                Status
              </p>
              <v-radio-group v-model="ActiveStatus" inline>
                <v-radio label="Active" value="1"></v-radio>
                <v-radio label="InActive" value="2"></v-radio>
              </v-radio-group> -->
            </v-col>
            <v-col col="12" md="6">
              <p style="text-align: center; font-size: 16px; color: black">
                Theme Color
              </p>
              <div align="center">
                <v-color-picker
                  dot-size="20"
                  class="ma-2"
                  v-model="ThemeColor"
                  mode="hexa"
                ></v-color-picker>
              </div>
              <!-- <p style="text-align: center; font-size: 20px; color: black">
                Theme Color
              </p>
              <div>
                <v-color-picker
                  dot-size="20"
                  class="ma-2"
                  v-model="ThemeColor"
                  mode="hexa"
                ></v-color-picker>
              </div> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <p style="text-align: center; font-size: 16px; color: black">
                Header Color
              </p>
              <div align="center">
                <v-color-picker
                  dot-size="20"
                  class="ma-2"
                  v-model="HeaderColor"
                  mode="hexa"
                ></v-color-picker>
              </div>
              <!-- <p style="text-align: center; font-size: 20px; color: black">
                Theme Color
              </p>
              <div>
                <v-color-picker
                  dot-size="20"
                  class="ma-2"
                  v-model="ThemeColor"
                  mode="hexa"
                ></v-color-picker>
              </div> -->
            </v-col>
            <v-col cols="12" md="6">
              <p style="text-align: center; font-size: 16px; color: black">
                Font Color
              </p>
              <div align="center">
                <v-color-picker
                  dot-size="20"
                  class="ma-2"
                  v-model="FontColor"
                  mode="hexa"
                ></v-color-picker>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <p style="font-size: 16px; color: black">Header Name</p>
              <v-text-field v-model="HeaderName" solo></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <p style="text-align: left; font-size: 16px; color: black">
                Status
              </p>
              <v-radio-group v-model="ActiveStatus">
                <v-radio label="Active" value="1"></v-radio>
                <v-radio label="InActive" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <hr class="mt-2" />
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10" align="right">
              <v-btn
                height="40"
                width="150"
                color="success"
                outlined
                @click="SaveSettingLogin()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
              <v-btn
                height="40"
                width="150"
                color="red"
                outlined
                @click="CloseSettingLoginPage()"
              >
                {{ $t("message.Cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
import LoadingComponent from "@/components/Loading";
export default {
  name: "Login",
  components: {
    LoadingComponent,
    AlertComponent
  },
  data() {
    return {
      model: "tab-1",
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",

      flagPassword: false,
      username: "",
      password: "",
      PathLogo: require("@/assets/FYILogo.png"),

      // DefaultLogo: require("@/assets/logo.png"),
      // PathLogoPony: require("@/assets/logo-pony.png"),

      CheckPermissionDialog: false,
      UserAdmin: "",
      PasswordAdmin: "",
      HeaderName: "",
      HeaderColor: "",
      FontColor: "",
      SettingLoginDialog: false,
      LogoImageString: "",
      LogoImageName: "",
      ThemeColor: "",
      ActiveStatus: "",
    };
  },

  mounted: function () {
    this.LoadDataSettingLogin();
    var Token = localStorage.getItem("Token");
    if (Token != null) {
      this.CheckLoginToken(Token);
    }
  },

  methods: {
    OpenCheckPermissionDialog() {
      let self = this;
      self.CheckPermissionDialog = true;
    },

    LoginPermission() {
      let self = this;
      if (
        self.UserAdmin.toLocaleLowerCase() == "admin" &&
        self.PasswordAdmin.toLocaleLowerCase() == "fscp_1"
      ) {
        self.OpenSettingLoginPage();
      } else {
        self.MessageAlert = "รหัสผ่านไม่ถูกต้อง !";
        self.TypeAlert = "error";
        self.AlertDialog = true;
      }
    },

    CloseCheckPermissionDialog() {
      let self = this;
      self.UserAdmin = "";
      self.PasswordAdmin = "";
      self.CheckPermissionDialog = false;
    },

    OpenSettingLoginPage() {
      let self = this;
      // self.CloseCheckPermissionDialog();
      self.SettingLoginDialog = true;
    },

    CloseSettingLoginPage() {
      let self = this;
      self.LogoImageString = "";
      self.LogoImageName = "";
      self.ThemeColor = "";
      self.SettingLoginDialog = false;
    },

    CloseSettingLogin() {
      let self = this;
      self.CheckPermissionDialog = false;
      self.SettingLoginDialog = false;
    },

    onPickFile() {
      let self = this;
      self.$refs.fileimagelogo.click();
    },

    handleFileInputLogo(data) {
      let files = data.target.files;
      files = data.target.files;
      var reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (data) => {
        this.LogoImageString = data.target.result;
        this.LogoImageName = files[0].name;
      };
    },

    SaveSettingLogin() {
      let self = this;
      // self.LoadingDialog = true;
      let temp = {
        HeaderName: self.HeaderName,
        HeaderColor: self.HeaderColor,
        FontColor: self.FontColor,
        LogoImageString: self.LogoImageString,
        LogoImageName: self.LogoImageName,
        ThemeColor: self.ThemeColor,
        ActiveStatus: self.ActiveStatus,
      };
      axios
        .post(`${self.url}Setting/AddSettingLoginPage`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SettingLoginDialog = false;
            self.CheckPermissionDialog = false;
            // self.LoadingDialog = false;
            self.LoadDataSettingLogin();
            self.CloseCheckPermissionDialog();
          } else {
            // self.LoadingDialog = false;
            self.MessageAlert = response.data.message;
            self.TypeAlert = "error";
            self.AlertDialog = true;
          }
        })
        .catch(function (error) {
          // self.LoadingDialog = false;
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    LoadDataSettingLogin() {
      let self = this;
      axios
        .get(`${self.url}Setting/LoadDataSettingLogin`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.HeaderColor = response.data.data.headerColor;
              self.HeaderName = response.data.data.headerName;
              self.FontColor = response.data.data.fontColor;
              self.LogoImageString = response.data.data.logoImageString;
              self.LogoImageName = response.data.data.logoImageName;
              self.ThemeColor = response.data.data.themeColor;
              self.ActiveStatus =
                response.data.data.activeStatus == true ? "1" : "2";
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    Login() {
      let self = this;
      if (!self.username || !self.password) {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน !");
      } else {
        self.LoadingDialog = true;
        let temp = {
          Username: self.username,
          Password: self.password,
        };
        axios
          .post(`${self.url}Login/Login`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.LoadingDialog = false;
              localStorage.setItem("UserID", response.data.data.login_id);
              localStorage.setItem("Username", self.username);
              localStorage.setItem("TenantID", response.data.data.tenantId);
              localStorage.setItem(
                "departmentId",
                response.data.data.departmentId
              );
              localStorage.setItem(
                "RedemptionType",
                response.data.data.redempType
              );
              localStorage.setItem("Token", response.data.data.token);
              localStorage.setItem("isLoggedIn", true);
              self.$router.push("/Main");
            } else {
              self.LoadingDialog = false;
              self.MessageAlert = response.data.message;
              self.TypeAlert = "error";
              self.AlertDialog = true;
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            self.MessageAlert = error;
            self.TypeAlert = "error";
            self.AlertDialog = true;
          });
      }
    },

    CheckLoginToken(value) {
      let self = this;
      let temp = {
        token: value,
      };
      axios
          .post(`${self.url}Login/CheckLoginToken`, temp)
          .then(function(response) {
            if (response.data.status == 0) {
              localStorage.setItem("UserID", response.data.data.login_id);
              localStorage.setItem("Username", self.username == "" ? response.data.data.username : self.username);
              localStorage.setItem("TenantID", response.data.data.tenantId);
              localStorage.setItem("departmentId", response.data.data.departmentId);
              localStorage.setItem("RedemptionType", response.data.data.redempType);
              localStorage.setItem("isLoggedIn", true);
              self.$router.push("/Main");
            }
            else if(response.data.status == 1 && response.data.message == "Token หมดอายุ"){
              localStorage.clear();
            }
            else {
              alert(response.data.message);
            }
          })
          .catch(function(error) {
            alert(error);
          });
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
    },
  },
};
</script>
<style scoped>
.login {
  width: 14rem;
}
.form {
  min-width: 50%;
}
.img-intersection {
  width: 100%;
  height: 100vh;
  max-width: 100%;
}
@media only screen and (max-width: 959px) {
  .logocss {
    display: none;
  }
  .rescss {
    margin: 1rem;
    width: 100% !important;
  }
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.image-container { 
    width:150px;
    height:120px;
    text-align:center;
}
.image-container img {
    height:100%;
}
.Header_Color{
  font-weight: bold;
}
</style>
